import React from 'react';
export function ContactSection() {
  return <section className="w-full py-16 px-6 md:px-12 bg-[var(--color-bg)]" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8" data-id="element-33">
          <div className="text-center mb-8" data-id="element-34">
            <h2 className="text-3xl font-bold text-[var(--color-text-dark)] mb-2" data-id="element-35">
              Contact us
            </h2>
            <p className="text-[var(--color-text-light)] text-sm" data-id="element-36">
              Tell us about your task, challenge, or project. We will review the
              request and get back to you with a clear and practical solution
            </p>
          </div>

          <form className="space-y-5" data-id="element-37">
            {/* Row 1 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-38">
              <div data-id="element-39">
                <label className="block text-sm font-medium text-[var(--color-text-dark)] mb-2" data-id="element-40">
                  Company name <span className="text-red-500" data-id="element-41">*</span>
                </label>
                <input type="text" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[var(--color-tan)] transition-colors" data-id="element-42" />
              </div>
              <div data-id="element-43">
                <label className="block text-sm font-medium text-[var(--color-text-dark)] mb-2" data-id="element-44">
                  Contact person <span className="text-red-500" data-id="element-45">*</span>
                </label>
                <input type="text" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[var(--color-tan)] transition-colors" data-id="element-46" />
              </div>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-47">
              <div data-id="element-48">
                <label className="block text-sm font-medium text-[var(--color-text-dark)] mb-2" data-id="element-49">
                  Email address <span className="text-red-500" data-id="element-50">*</span>
                </label>
                <input type="email" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[var(--color-tan)] transition-colors" data-id="element-51" />
              </div>
              <div data-id="element-52">
                <label className="block text-sm font-medium text-[var(--color-text-dark)] mb-2" data-id="element-53">
                  Phone / WhatsApp <span className="text-red-500" data-id="element-54">*</span>
                </label>
                <input type="tel" placeholder="+38 (0XX) XXX XX XX" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[var(--color-tan)] transition-colors placeholder:text-gray-400" data-id="element-55" />
              </div>
            </div>

            {/* Textarea */}
            <div data-id="element-56">
              <label className="block text-sm font-medium text-[var(--color-text-dark)] mb-2" data-id="element-57">
                Describe your task or request{' '}
                <span className="text-red-500" data-id="element-58">*</span>
              </label>
              <textarea rows={4} placeholder="Enter text" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[var(--color-tan)] transition-colors resize-none placeholder:text-gray-400" data-id="element-59" />
            </div>

            {/* Project type */}
            <div data-id="element-60">
              <label className="block text-sm font-medium text-[var(--color-text-dark)] mb-2" data-id="element-61">
                Project / Vessel type
              </label>
              <input type="text" className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[var(--color-tan)] transition-colors" data-id="element-62" />
            </div>

            {/* File upload */}
            <div className="border border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-gray-400 transition-colors" data-id="element-63">
              <div className="flex items-center justify-center gap-2 text-[var(--color-text-light)] text-sm" data-id="element-64">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-65">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" data-id="element-66" />
                </svg>
                <span data-id="element-67">Attach files (PDF, Word, Excel, images)</span>
              </div>
            </div>

            {/* Submit button - Centered */}
            <div className="flex justify-center pt-2" data-id="element-68">
              <button type="submit" className="px-8 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity" data-id="element-69">
                Submit Request
              </button>
            </div>

            <p className="text-xs text-[var(--color-text-light)] text-center" data-id="element-70">
              All information is treated confidentially. We do not share your
              data with third parties
            </p>
          </form>
        </div>
      </div>
    </section>;
}